<template>
  <section v-if="title || body"
           class="before-footer-text  container">
    <div class="before-footer-text__content  container-inner">
      <h2 v-if="title"
          class="before-footer-text__title">{{ title }}</h2>
      <div v-if="body"
           v-html="body"
           class="before-footer-text__text  text"></div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'CreditsPageText',
    props: {
      title: String,
      body: String,
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
